module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SluIla/tc-custom/9781626811867.jpg?1699984743072",
      "alt": "This image is the cover for the book Secrets of a Midnight Moon, The Moon Trilogy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Secrets of a Midnight Moon, The Moon Trilogy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("For a young teacher in nineteenth century California, every road away from her past leads into the arms of a dangerous man—until she meets the right one.")]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("California, 1858")]), _vm._v(". After being abandoned by her lover and shunned by her family, Anna Jenson decides to make a new start in the rugged wilderness of the California mountains. But before she can reach her destination and begin her new life as a humble schoolteacher, she’s captured by a brooding warrior known only as “Bear.”"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Her kidnapping wasn’t entirely random, though. Bear is actually Nicholas Gaspard, the half-Indian son of the rich rancher who hired Anna. He abducted her for what he believes to be a greater cause. Nicholas is a local hero, rescuing abandoned and abused local children, and he wants Anna to educate them. Furious at being tricked, Anna initially resists. But sparks fly between the reluctant teacher and the complex man, revealing a reckless desire that cannot be tamed."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Jane Bonander reaches to her readers’ hearts.” —"), _c('i', [_vm._v("RT Book Reviews")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jane Bonander\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0